// services/api.js
import axios from "axios";
import { API_BASE_URL } from "../constants/apiConstants";

// Default API instance
const api = axios.create({
  baseURL: API_BASE_URL,
  // timeout: 40000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Secondary API instance
// const api1 = axios.create({
//   baseURL: API_BASE_URL_1,
//   timeout: 10000,
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

// Common request interceptor
const requestInterceptor = (config) => {
  const token = localStorage.getItem("token");
  if (token) {
    // config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

// Common response interceptors
const responseInterceptor = (response) => response;
const errorInterceptor = (error) => {
  if (error.response && error.response.status === 401) {
    console.error("Unauthorized. Redirecting to login...");
  }
  return Promise.reject(error);
};

// Attach interceptors to both instances
[api].forEach((instance) => {
  instance.interceptors.request.use(requestInterceptor, Promise.reject);
  instance.interceptors.response.use(responseInterceptor, errorInterceptor);
});

// Export default and named instance
export default api;
// export { api1 };
